module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDkgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNOSA2TDIuMDQwODZlLTA2IDExLjE5NjJMMS45MTY5M2UtMDYgMC44MDM4NDhMOSA2WiIgZmlsbD0iI0Y2RDlBQSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/triangle.svg
// module id = SnNW
// module chunks = 1